<template>
    <div class='container-fluid'>
      <b-row>
        <b-col>
          <h4>Select Customer</h4>
          <v-select label="email" :options="customers_collection" @input="changeRoute" />
        </b-col>
      </b-row>
      <router-view />
    </div>
</template>

<script>
import Customer from './Show'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'Customers',
  computed: {
    ...mapGetters(['customers_collection'])
  },

  created () {
    this.loadCustomers()
  },

  methods: {
    ...mapActions(['loadCustomers']),
    changeRoute (customer) {
      this.$router.push({path: `/customers/${customer.id}`})
    }
  },
  components: {
    Customer
  }
}
</script>

<style scoped>
  .v-select {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/Index.vue